export const getLabel = key => {
  switch (key) {
    case "semester_type":
      return "Вид семестър";

    case "academic_year":
      return "Академична година";

    case "student_all_names":
      return "Имена на студента";

    case "country_citizenship":
      return "Гражданство";

    case "person_id":
      return "ЕГН";

    case "residential_address":
      return "Адрес";

    case "identity_card_number":
      return "Номер на лична карта";

    case "identity_card_issued_date":
      return "Дата на издаване на лична карта";

    case "identity_card_issued_by":
      return "Издадена от";

    case "professional_direction":
      return "Професионално направление";

    case "faculty":
      return "Факултет";

    case "speciality":
      return "Специалност";

    case "faculty_number":
      return "Факултетен номер";

    case "ean_number":
      return "ЕАН номер";

    case "qualification_degree":
      return "Образователно-квалификационна степен";

    case "has_acquired_qualification_degree":
      return "Придобита квалификационна степен";

    case "study_duration_in_semesters":
      return "Продължителност на обучението (семестри)";

    case "study_type":
      return "Форма на обучение";

    case "number_of_months_in_winter_semester":
      return "Брой месеци в зимен семестър";

    case "number_of_months_in_summer_semester":
      return "Брой месеци в летен семестър";

    case "final_exam_deadline":
      return "Краен срок за държавни изпити";

    case "annual_fee_euros":
      return "Годишна такса (EUR)";

    case "semester_fee_euros":
      return "Семестриална такса (EUR)";

    case "semester_fee_in_words":
      return "Семестриална такса (словом)";

    case "semester_fee_payment_deadline":
      return "Краен срок за плащане на семестриална такса";

    case "university_iban_number":
      return "IBAN на университета";

    case "university_account_number":
      return "Номер на сметка на университета";

    case "university_bank_name":
      return "Име на банката";

    default:
      return key;
  }
};
